import { Box } from "@chakra-ui/react";

import SettingsLayout from "~/components/settings/SettingsLayout";
import Meta from "~/layout/Meta";

const SettingsPage = () => {
  return (
    <>
      <Meta title="Settings" />
      <Box py={4}>
        <SettingsLayout />
      </Box>
    </>
  );
};

export default SettingsPage;
